import { Typography, Stack, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Catch-all 404 page. Keeps the user on the site (rather than a blank
 * page) and links back to home.
 */
export function NotFoundPage() {
  return (
    <Stack spacing={2}>
      <Typography variant="h1">Page not found</Typography>
      <Typography variant="body1">
        The page you tried to reach does not exist.{' '}
        <Link component={RouterLink} to="/">
          Return home
        </Link>
        .
      </Typography>
    </Stack>
  );
}

export default NotFoundPage;
